import { render, staticRenderFns } from "./show.vue?vue&type=template&id=5417e109&scoped=true&"
import script from "./show.vue?vue&type=script&lang=ts&"
export * from "./show.vue?vue&type=script&lang=ts&"
import style0 from "./show.vue?vue&type=style&index=0&id=5417e109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5417e109",
  null
  
)

export default component.exports